import { render, staticRenderFns } from "./DigitalAgricultureSolutions.vue?vue&type=template&id=9c8ded44&scoped=true"
import script from "./DigitalAgricultureSolutions.vue?vue&type=script&lang=js"
export * from "./DigitalAgricultureSolutions.vue?vue&type=script&lang=js"
import style0 from "./DigitalAgricultureSolutions.vue?vue&type=style&index=0&id=9c8ded44&prod&lang=scss&scoped=true"
import style1 from "./DigitalAgricultureSolutions.vue?vue&type=style&index=1&id=9c8ded44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8ded44",
  null
  
)

export default component.exports